import { useQuery } from "@tanstack/react-query";
import axiosInstance from "../../api";

function useStateAndCity() {
  const { data, isPending, error, isLoading } = useQuery({
    queryKey: ["state_city"],
    queryFn: () => axiosInstance.get("v1/states").then((res) => res.data.data),
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });

  return { isPending, data, error, isLoading };
}

export default useStateAndCity;
